export const DEFAULT_LABEL_PALETTE = [
  "#00bcd4",
  "#4caf50",
  "#ffc107",
  "#e91e63",
  "#9c27b0",
  "#f44336",
  "#607d8b",
  "#ff9800",
  "#795548",
  "#3f51b5",
  "#2196f3",
  "#8bc34a",
];

export const buildLabelsFromValues = (
  values = [],
  palette = DEFAULT_LABEL_PALETTE
) => {
  const unique = Array.from(new Set(values.filter(Boolean)));
  return unique.map((name, idx) => ({
    id: `${String(name).toLowerCase().replace(/\s+/g, "-")}-${idx}`,
    name: String(name),
    color: palette[idx % palette.length],
  }));
};

export const mergeLabelsFromValues = (
  labels = [],
  values = [],
  palette = DEFAULT_LABEL_PALETTE
) => {
  const existing = new Set(labels.map((l) => l.name));
  const incoming = Array.from(new Set(values.filter(Boolean))).filter(
    (v) => !existing.has(v)
  );
  if (!incoming.length) return labels;
  const start = labels.length;
  const next = incoming.map((name, idx) => ({
    id: `${String(name).toLowerCase().replace(/\s+/g, "-")}-${start + idx}`,
    name: String(name),
    color: palette[(start + idx) % palette.length],
  }));
  return [...labels, ...next];
};

export const toLabelOptions = (labels = []) =>
  labels.map((l) => ({
    value: l.name,
    label: l.name,
    color: l.color,
  }));

export const toLabelColorMap = (labels = []) =>
  labels.reduce((acc, l) => {
    acc[l.name] = l.color;
    return acc;
  }, {});
